// ─── 전일 대비 증감 배지 ─────────────────────────────────────────────────────
import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';

/**
 * 오늘(curr)과 어제(prev) 건수를 비교해 증감 방향과 차이를 배지로 표시합니다.
 * @param {{ curr: number|null, prev: number|null }} props
 */
export default function TrendBadge({ curr, prev }) {
  if (prev == null || curr == null) return null;
  const diff = curr - prev;
  if (diff === 0)
    return <span className="text-sm text-gray-400">전일 대비 동일</span>;

  const up = diff > 0;
  return (
    <span className={`inline-flex items-center gap-1 text-sm font-semibold ${up ? 'text-emerald-600' : 'text-red-500'}`}>
      {up ? <ArrowUp size={13} /> : <ArrowDown size={13} />}
      {up ? '+' : ''}{diff}건 전일 대비
    </span>
  );
}
